import { useQuery } from '@tanstack/react-query'

// TODO: Replace with actual API calls when available
const getClients = async () => {
  // Simulate API call
  await new Promise(resolve => setTimeout(resolve, 500))
  return [
    { id: 1, name: 'Cliente A' },
    { id: 2, name: 'Cliente B' },
    { id: 3, name: 'Cliente C' },
    { id: 4, name: 'Cliente D' },
    { id: 5, name: 'Cliente E' },
  ]
}

export function useClientsForFilters() {
  return useQuery({
    queryKey: ['clients-for-filters'],
    queryFn: () => getClients(),
    staleTime: 5 * 60 * 1000, // 5 minutos
  })
}

// Hook consolidado para obtener todas las opciones de filtros
export function useFilterOptions() {
  const clientsQuery = useClientsForFilters()

  // Transformar datos para el formato de SelectFilter
  const clientOptions = [
    { value: 'all', label: 'Todos los clientes' },
    ...(clientsQuery.data || []).map(client => ({
      value: client.id.toString(),
      label: client.name
    }))
  ]

  return {
    clientOptions,
    isLoading: clientsQuery.isLoading,
    error: clientsQuery.error
  }
}
